<script>
  import { Line, mixins } from 'vue-chartjs';

  const { reactiveProp } = mixins;

  export default {
    extends: Line,
    name: 'cat-proficiency-chart',
    mixins: [reactiveProp],
    props: [
      'chartData',
      'chartFontColor',
    ],
    data() {
      return {
        defaultOptions: {
          responsive: true,
          maintainAspectRatio: false,
          gradient: null,
        },
        options: {
          scales: {
            pointLabels: {
              display: true,
              fontColor: 'rgba(0, 0, 0, 0)',
              fontSize: 12,
            },
            yAxes: [{
              gridLines: {
                zeroLineWidth: 1,
                scaleShowGridLines: true,
                display: false,
                drawBorder: true,
                color: 'rgba(255, 255, 255, 0.4)',
              },
              scaleLabel: {
                display: false,
              },
              scaleShowLabels: false,
              ticks: {
                display: true,
                beginAtZero: true,
                stepSize: 250,
                fontColor: this.chartFontColor,
                fontSize: 12,
              },
            }],
            xAxes: [{
              position: 'bottom',
              gridLines: {
                display: false,
                scaleShowGridLines: true,
                drawBorder: true,
                color: 'rgba(255, 255, 255, 0.4)',
              },
              ticks: {
                display: true,
                beginAtZero: false,
                fontColor: this.chartFontColor,
                fontSize: 12,
              },
            }],
          },
          legend: {
            display: false,
          },
        },
      };
    },

    mounted() {
      this.gradient = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 350);
      this.gradient.addColorStop(0, 'rgba(255,255,255, 0.1)');
      this.gradient.addColorStop(1, 'rgba(255,255,255, 0.4)');
      this.renderChart(this.chartData, { ...this.options }, { ...this.defaultOptions });
    },
  };
</script>



// WEBPACK FOOTER //
// CatProficiencyChart.vue?a59cb358